document.addEventListener("DOMContentLoaded", () => {

    const sticky = document.getElementById("wwStickyCart");
    if (!sticky) return;

    const addToCart = document.querySelector('button[name="add"]');
    const stickyButton = document.getElementById("wwStickyAddToCart");

    if (!addToCart || !stickyButton) return;

    function toggleSticky() {

        const rect = addToCart.getBoundingClientRect();

        if (rect.bottom < 0) {
            sticky.classList.add("active");
        } else {
            sticky.classList.remove("active");
        }

    }

    window.addEventListener("scroll", toggleSticky);

    toggleSticky();

    // Sticky Add to Cart
    stickyButton.addEventListener("click", () => {

        addToCart.click();

    });

});